<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<div class="image_container1">
<img alt="images" src="images/f0ii-01.jpg"/>
<p class="caption">The official portrait of Goodall with his signature which appeared in <em class="italic">The Shipbuilder</em> in September 1936 with the announcement of his appointment as DNC.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Front.vue?497788d2